module.exports = __webpack_public_path__ + "img/ru.47960282.png";